module.exports = "/_next/static/resources/purpose-eda9e6c1acd4531a3068e30922e59853.jpg";